// extracted by mini-css-extract-plugin
export default {"root":"HeartConfirmation-root","title":"HeartConfirmation-title","text":"HeartConfirmation-text","image":"HeartConfirmation-image"};